import { create } from "zustand";
import { putUpdate, postFeedback, postInterventionPrescription, getlastUnansweredMedicalSlot, getDoctorSlot, bookDoctorSlot, markAdhocCallDone } from "../api";
import { Spinner } from "react-bootstrap";
import { TOAST_MESSAGE_CSS } from "modules/utilities/utility";
import { toast } from 'react-toastify';

export const useUpdateFeedBack = create((set) => ({
  feedbackResponse: {},
  isLoading: false,
  isError: false,
  errorMessage: "",

  updateFeedback: async ( setShow, id, feedback, setFeedbackButton, fetchTodayEngData, fetchTempEngData, fetchBookingData, setData, setBooking, customerId, engagementType, navigate, setActiveOrder) => {
    setFeedbackButton({text: <span><Spinner size="sm" className="me-2" />Setting Reminder</span>,variant: "success",});
    set({ isLoading: true });
    try {
      if(setActiveOrder){ 
        setActiveOrder(0); };
        const response = await putUpdate(id, feedback);
        set({ feedbackResponse: response.data, isLoading: false });
        setFeedbackButton({ text: "Reminder set", variant: "success" });
    } catch (error) {
      set({ isError: true, isLoading: false, errorMessage: error?.response.data.message });
      setFeedbackButton({ text: "Failed to set reminder", variant: "danger" });
    } finally {
      fetchBookingData && fetchBookingData(customerId, setData, setBooking);
      engagementType === "temporary" ? fetchTempEngData() : fetchTodayEngData();
      if(navigate){
        setTimeout(() => {
          navigate("/next-call");
          setShow(false);
        }, 2000);
      }
    }
  },
  markAdhocCallDone: async (caseId, payload, setShow) =>{
    try{
      await markAdhocCallDone(caseId, payload);
      toast.success('call disposed');
    } catch (error) {
      console.error('markAdhocCallDone', error);
      toast.error('failed to dispose call');
    } finally{
      setShow(false);
    }
  }
}));

export const useAddFeedback = create((set) => ({
  addFeedBackResponse: {},
  isLoading: false,
  isError: false,
  errorMessage: "",
  addFeedback: async (id, feedbackResponse, setFeedbackButton) => {
    setFeedbackButton({
      text: "Updating Feedback",
      variant: "primary",
    });
    set({ isLoading: true });
    try {
      const response = await postFeedback(id, feedbackResponse);
      set({ addFeedBackResponse: response.data, isLoading: false });
      setFeedbackButton({
        text: "Feedback Updated",
        variant: "success",
      });
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
      setFeedbackButton({
        text: "Failed to update feedback",
        variant: "success",
      });
    } finally {
      setTimeout(() => {
        setFeedbackButton({
          text: "Save Feedback",
          variant: "primary",
        });
      }, 5000);
    }
  },
}));

export const useAddMedicalSlotFeedback = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  addMedicalSLotCall: async (id, feedback) => {
    set({ isLoading: true });
    try {
      await putUpdate(id, feedback);
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
}));

export const useInterventionPrescription = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  prescription : [],
  addInterventionPrescription: async (id, prescription, toast, handleClose) => {
    set({ isLoading: true,isError:false,  });
    try {
      const result = await postInterventionPrescription(id, prescription);
      set({ isLoading: false,isError:false, prescription: result.data });
      toast.success("Prescription written successfully",TOAST_MESSAGE_CSS);
      handleClose();
    } catch (error) {
      toast.error("Prescription Writing Failed",TOAST_MESSAGE_CSS);
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
}));

// export const lastUnansweredMedicalSlot = create((set)=>{
//   // prescription : [],
//   calllastUnansweredMedicalSlot : async (id) =>{
//     try {
      
//     } catch (error) {
      
//     }
//   }
// })
export const lastUnansweredMedicalSlot = create((set) => ({
  isLoading: false,
  isError: false,
  errorMessage: "",
  lastUnansweredMedicalSlotData: {},
  calllastUnansweredMedicalSlot: async (id) => {
    set({ isLoading: true });
    try {
      const result = await getlastUnansweredMedicalSlot(id);
      set({lastUnansweredMedicalSlotData : result.data})
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
}));

export const useAllDoctorSlot = create((set) => ({
  isLoading: false,
  bookLoading: false,
  isError: false,
  errorMessage: "",
  doctorSlotData: {},
  fetchAllDoctorSlot: async (caseId) => {
    set({ isLoading: true, isError:null });
    try {
      const result = await getDoctorSlot(caseId);
      set({doctorSlotData : result.data, isLoading:false})
    } catch (error) {
      set({
        isError: true,
        isLoading: false,
        errorMessage: error?.response.data.message,
      });
    }
  },
  postDoctorSlotBooking: async (caseId, payload, handleClose, toast, setSlotBooked) => {
    set({ bookLoading: true, isError:null });
    try {
      const result = await bookDoctorSlot(caseId, payload);
      toast.success('Slot booked successfully');
      set({bookLoading:false, isError:false});
      setSlotBooked(result.data);
      handleClose();
    } catch (error) {
      set({
        isError: true,
        bookLoading: false,
        errorMessage: error?.response?.data?.message,
      });
      toast.error(`${error?.response?.data?.message || 'Slot booking is failed'}`)
    }
  },
}));